import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './auth/AuthContext.jsx';
import Layout from './components/Layout.jsx';
import HomePage from './pages/HomePage.jsx';
import BookingTunnel from './pages/BookingTunnel.jsx';
import ReservationStatus from './pages/ReservationStatus.jsx';
import Login from './pages/auth/Login.jsx';
import SignUp from './pages/auth/SignUp.jsx';
import ForgotPassword from './pages/auth/ForgotPassword.jsx';
import Profile from './pages/account/Profile.jsx';
import MyReservations from './pages/account/MyReservations.jsx';
import Loyalty from './pages/account/Loyalty.jsx';
import RedeemPoints from './pages/account/RedeemPoints.jsx';

function ProtectedRoute({ children }) {
  const { isAuthenticated, loading } = useAuth();
  if (loading) return null;
  if (!isAuthenticated) return <Navigate to="/compte/connexion" replace />;
  return children;
}

export default function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<HomePage />} />
        <Route path="reserver/:siteCode" element={<BookingTunnel />} />
        <Route path="reservation/:code" element={<ReservationStatus />} />

        <Route path="compte/connexion" element={<Login />} />
        <Route path="compte/inscription" element={<SignUp />} />
        <Route path="compte/mot-de-passe-oublie" element={<ForgotPassword />} />

        <Route path="compte/profil" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
        <Route path="compte/reservations" element={<ProtectedRoute><MyReservations /></ProtectedRoute>} />
        <Route path="compte/fidelite" element={<ProtectedRoute><Loyalty /></ProtectedRoute>} />
        <Route path="compte/fidelite/echanger" element={<ProtectedRoute><RedeemPoints /></ProtectedRoute>} />

        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}
